export class SalesSttings {
AutomaticTax: number;
DiscountTax: number;
AutomaticDiscount:number;
}